import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { refreshLabels } from "@/lib/labels";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Save, RotateCcw } from "lucide-react";
import { toast } from "sonner";

const GROUPS = [
  ["Product cards (homepage, search, categories, brands)", [
    ["in_stock_badge", "In-stock badge"], ["out_of_stock_badge", "Out-of-stock badge"], ["add_to_cart", "Add to cart button"],
    ["enquire_button", "Out-of-stock button (tablet/desktop)"], ["enquire_button_mobile", "Out-of-stock button (phones)"],
    ["request_quote", "No-price (POA) button"], ["poa_price", "No-price text"], ["incl_gst", "Text after price"],
    ["save_prefix", "Saving prefix"], ["rrp_prefix", "RRP prefix"]]],
  ["Product page", [
    ["pdp_in_stock", "In-stock badge ({stock} = quantity)"], ["pdp_out_of_stock", "Out-of-stock badge"], ["pdp_enquire_button", "Out-of-stock button"]]],
];

export default function ProductWordingTab() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/site/labels").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="text-muted-foreground">Loading…</p>;
  const set = (k, v) => setD({ ...d, values: { ...d.values, [k]: v } });
  const save = async (vals) => {
    try { const r = await api.put("/admin/site/labels", vals); setD({ ...d, values: r.data }); await refreshLabels(); toast.success("Wording saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  return (
    <div className="max-w-4xl space-y-4" data-testid="product-wording-tab">
      <div><h1 className="text-2xl sm:text-3xl font-extrabold mb-1">Product Wording</h1>
        <p className="text-muted-foreground text-sm">Change the words on product cards and product pages. Button text shrinks and wraps automatically to fit every screen. Leave a field blank to use the default.</p></div>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => save(d.values)} className="bg-accent text-steel font-semibold" data-testid="wording-save"><Save size={15} className="mr-1.5" /> Save</Button>
        <Button variant="outline" onClick={() => window.confirm("Restore all default wording?") && save({})} data-testid="wording-reset"><RotateCcw size={15} className="mr-1.5" /> Restore defaults</Button>
      </div>
      {GROUPS.map(([title, fields]) => (
        <section key={title} className="rounded-xl border bg-white p-4 sm:p-5">
          <h2 className="font-bold text-steel mb-3">{title}</h2>
          <div className="grid sm:grid-cols-2 gap-3">
            {fields.map(([k, label]) => (
              <div key={k}><Label className="text-xs">{label}</Label>
                <Input value={d.values[k]} maxLength={60} placeholder={d.defaults[k]} onChange={(e) => set(k, e.target.value)} data-testid={`wording-${k}`} /></div>))}
          </div>
        </section>))}
    </div>
  );
}
